import { lessonAtom } from "@core/grades/atoms";
import { useLessonOffers } from "../hooks";
import { OffersSection } from "./OffersSection";

export function LessonOffersTab() {
  const lesson = lessonAtom.useValue();
  const { offers, isLoading, error, fetchOffers, hasLoaded } = useLessonOffers(
    lesson.id,
  );

  return (
    <OffersSection
      offers={offers}
      isLoading={isLoading}
      error={error}
      onFetchOffers={fetchOffers}
      hasLoaded={hasLoaded}
    />
  );
}
